import { Fragment, useEffect, useRef, useState } from "react";
import Spinner from "../../../components/spinner/Spinner";
import {
    GetAdminDefaultSettings,
    GetReportSettings,
    GetSalesCompanyDetailsBasic,
    GetSalesCompanyTaskDetails,
    GetSalesCompanyTaskDetailsWithSproc,
    GetSalesCompanyTaskDetailsWithSprocBasic,
} from "../../../Services";
import { useParams } from "react-router-dom";
import GridMapV5 from "../../../components/gridReport/v5/gridMap/GridMapV5";
import "./AuditReportPublicView.css";
import moment from "moment";
import {
    GetNormalizedReportDataByCompanyId,
    GetNormalizedReportDataByTaskIdFromDb,
    GetReportAnalizedSummaryData,
} from "../../../ReportAPI";
import { getHighlightedText, capitalize, isNumber } from "../../../utils/Common";
import ModalDialog from "../../../components/modalDialog/ModalDialog";
import ModalDialogContent from "../../../components/modalDialog/modalDialogContent/ModalDialogContent";
import ModalDialogButtons from "../../../components/modalDialog/modalDialogButtons/ModalDialogButtons";
import RatingStars from "../../../components/ratingStars/RatingStars";

const AuditReportPublicView = () => {
    const [isLoadingTask, setIsLoadingTask] = useState(true);
    const [isLoadingSummaryData, setIsLoadingSummaryData] = useState(true);
    const [isLoadingMap, setIsLoadingMap] = useState(false);
    const [isLoadingAuditData, setIsLoadingAuditData] = useState(false);
    const [companyData, setCompanyData] = useState();
    const [mapGridData, setMapGridData] = useState();
    const [taskGridData, setTaskGridData] = useState();
    const [task, setTask] = useState();
    const { reportId } = useParams();
    const [gridKeywords, setGridKeywords] = useState();
    const [selectedKeyword, setSelectedKeyword] = useState();
    const [adminSettings, setAdminSettings] = useState();
    const [powerCitationsWebsites, setPowerCitationsWebsites] = useState();
    const [powerContentWebsites, setPowerContentWebsites] = useState();
    const [reportSettings, setReportSettings] = useState();
    const [competitorsData, setCompetitorsData] = useState();
    const [showCompetitorsPanel, setShowCompetitorsPanel] = useState(false);
    const [selectedCompetitorOnMap, setSelectedCompetitorOnMap] = useState();
    const [auditResponseData, setAuditResponseData] = useState();
    const [auditKeywordData, setAuditKeywordData] = useState();
    const [selectedIndustryCategory, setSelectedIndustryCategory] = useState();
    const [showJsonOutputDialog, setShowJsonOutputDialog] = useState(false);
    const [jsonOutput, setJsonOutput] = useState();
    const [summaryData, setSummaryData] = useState();
    const [summaryItemsForProfile, setSummaryItemsForProfile] = useState();
    const [summaryItemsProminence, setSummaryItemsProminence] = useState();
    const [summaryItemsReviews, setSummaryItemsReviews] = useState();
    const [summaryItemsForKeywords, setSummaryItemsForKeywords] = useState();
    const [businessGridAverageData, setBusinessGridAverageData] = useState();
    const [businessGridAverageDataByKeyword, setBusinessGridAverageDataByKeyword] = useState();
    const [businessRatingData, setBusinessRatingData] = useState();
    const [selectedCompanyRanking, setSelectedCompanyRanking] = useState();
    const rankingsTypes = [
        { label: "Average", value: "average" },
        { label: "Top 3", value: "top3Count" },
        { label: "4-10", value: "top10Count" },
        { label: "11-20", value: "top20Count" },
        { label: "21+", value: "above20Count" },
    ];
    const [currentReportTab, setCurrentReportTab] = useState("summary");

    const settings = [
        { label: "Categories", propName: "categories", printPropName: "profile.categories", checkboxName: "Profile" },
        { label: "Address", propName: "address", printPropName: "profile.address" },
        { label: "Phone Number", propName: "phoneNumber", printPropName: "profile.phone" },
        { label: "Website URL", propName: "websiteUrl", printPropName: "profile.website" },
        { label: "Contact URL", propName: "contactUrl", printPropName: "profile.contactUrl" },
        { label: "Description", propName: "description", printPropName: "profile.description", shouldTruncate: false },
        { label: "Business Hours", propName: "businessHours", printPropName: "workTime" },
        { label: "Total Reviews", propName: "totalReviews", printPropName: "reviews" },
        { label: "Total Posts", propName: "totalPosts", printPropName: "posts", checkboxName: "TotalPosts" },
        { label: "Total Q&A", propName: "totalQA", printPropName: "qa", checkboxName: "TotalQA" },
        { label: "Total Images", propName: "totalPhotos" },
        { label: "Logo", propName: "logo", printPropName: "profile.logo" },
        { label: "Main Image", propName: "mainImage", printPropName: "profile.mainImage" },
        { label: "Social Profiles", propName: "socialProfiles", printPropName: "profile.socialProfiles" },
    ];
    const kwSettings = [
        {
            label: "Profile Categories",
            propName: "keywordInCategories",
            printPropName: "profile.categories",
            hoverPropName: "occurrencesInCategories",
            highlightText: true,
        },
        {
            label: "Profile Title",
            propName: "keywordInTitle",
            printPropName: "profile.title",
            hoverPropName: "occurrencesInTitle",
            highlightText: true,
        },
        {
            label: "Profile Description",
            propName: "keywordInDescription",
            printPropName: "profile.description",
            hoverPropName: "occurrencesInDescription",
            shouldTruncate: false,
            highlightText: true,
        },
        {
            label: "Profile Reviews (Last 20)",
            propName: "keywordInReviews",
            printPropName: "reviews.last20",
            hoverPropName: "occurrencesInReviews",
            checkboxName: "TotalReviews",
            highlightText: true,
        },
        {
            label: "Profile Posts",
            propName: "keywordInPosts",
            printPropName: "posts",
            hoverPropName: "occurrencesInPosts",
            checkboxName: "TotalPosts",
            highlightText: true,
        },
        {
            label: "Profile Q&A",
            propName: "keywordInQA",
            printPropName: "qa",
            hoverPropName: "occurrencesInQA",
            checkboxName: "TotalQA",
            highlightText: true,
        },
        {
            label: "Website Landing Page",
            propName: "keywordInWebsiteLandingPage",
            // printPropName : 'occurrencesInHtml',
            hoverPropName: "occurrencesInHtml",
            checkboxName: "WebsiteLandingPage",
            highlightText: true,
        },
        {
            label: "Website Pages Indexed",
            propName: "keywordWebsitePagesIndexed",
            printPropName: "indexedPagesByKeyword.results",
            hoverPropName: "occurrencesInIndexedPages",
            checkboxName: "KeywordDensityOnIndexedPages",
            // highlightText : true
        },
    ];
    const reviewsLast20Settings = [
        { label: "Average Rating", propName: "last20AverageRating" },
        { label: "Average Words Per Review", propName: "last20AverageWordsPerReview" },
        // { label: 'Have Replies', propName: 'last20HaveReplies' },
        { label: "Do Not Have Replies", propName: "last20DoNotHaveReplies" },
        { label: "Local Guide Reviews", propName: "last20LocalGuideReviews" },
        { label: "Negative Reviews", propName: "last20NegativeReviews" },
        // { label: 'Negative Reviews Have Replies', propName: 'last20NegativeReviewsHaveReplies' },
        { label: "Negative Reviews Do Not Have Replies", propName: "last20NegativeReviewsDoNotHaveReplies" },
    ];
    const reviewsLast30DaysSettings = [
        { label: "Total Reviews", propName: "last30TotalReviews" },
        { label: "Average Rating", propName: "last30AverageRating" },
        { label: "Average Words Per Review", propName: "last30AverageWordsPerReview" },
        // { label: 'Have Replies', propName: 'last30HaveReplies' },
        { label: "Do Not Have Replies", propName: "last30DoNotHaveReplies" },
        { label: "Local Guide Reviews", propName: "last30LocalGuideReviews" },
        { label: "Negative Reviews", propName: "last30NegativeReviews" },
        // { label: 'Negative Reviews Have Replies', propName: 'last30NegativeReviewsHaveReplies' },
        { label: "Negative Reviews Do Not Have Replies", propName: "last30NegativeReviewsDoNotHaveReplies" },
    ];
    const cssRef = useRef(null);

    //scroll event
    useEffect(() => {
        window.addEventListener("scroll", storeScrollPosition);

        return () => {
            window.removeEventListener("scroll", storeScrollPosition);
        };
    }, []);

    //get task details
    useEffect(() => {
        if (reportId) {
            getAdminSettings();
            getReportSettings();
            updateViewPortMetaTag();
            getSalesCompanyTask();
        }
    }, [reportId]);

    //mapReady event
    useEffect(() => {
        if (window.mapReady) {
            setIsLoadingMap(false);
        }
    }, [window.mapReady]);

    //custom code scripts
    useEffect(() => {
        if (adminSettings && adminSettings.customCode) {
            const { headJSScript, bodyJSScript, cssStyle } = adminSettings?.customCode ?? {};

            let headScript = null;
            if (headJSScript) {
                headScript = document.createElement("script");
                headScript.text = headJSScript;
                document.head.appendChild(headScript);
            }

            let bodyScript = null;
            if (bodyJSScript) {
                bodyScript = document.createElement("script");
                bodyScript.text = bodyJSScript;
                document.body.appendChild(bodyScript);
            }

            let styleTag = null;
            if (cssStyle) {
                styleTag = document.createElement("style");
                styleTag.textContent = cssStyle;
                document.head.appendChild(styleTag);
                cssRef.current = styleTag;
            }

            // Cleanup on unmount or when code changes
            return () => {
                if (headScript) document.head.removeChild(headScript);
                if (bodyScript) document.body.removeChild(bodyScript);
                if (styleTag) document.head.removeChild(styleTag);
            };
        }
    }, [adminSettings?.customCode?.headJSScript, adminSettings?.customCode?.bodyJSScript, adminSettings?.customCode?.cssStyle]);

    //update viewport meta tag to display always desktop version (only for this page)
    const updateViewPortMetaTag = () => {
        const viewport = document.querySelector("meta[name='viewport']");

        if (viewport) {
            viewport.setAttribute("content", "width=1200,initial-scale=1");
        }
    };

    const getAdminSettings = async () => {
        let response = await GetAdminDefaultSettings();

        if (response && response.data) {
            setAdminSettings(response.data);
        }
    };

    const getReportSettings = async () => {
        let response = await GetReportSettings();

        if (response && response.data) {
            setReportSettings(response.data);
        }
    };

    const getCompanyDetails = async (id) => {
        let response = await GetSalesCompanyDetailsBasic(id);

        if (response) {
            setCompanyData(response);
        }
    };

    const getSalesCompanyTask = async () => {
        //setIsLoadingTask(true);

        const response = await GetSalesCompanyTaskDetailsWithSprocBasic(reportId);

        if (response) {
            setTask(response);

            if (response.salesCompanyId) {
                await getCompanyDetails(response.salesCompanyId);
            }
        }

        setIsLoadingMap(false);
        setIsLoadingTask(false);
    };

    //get grid and audit data
    useEffect(() => {
        if (task) {
            getReportGridData(task.id);
            // getNormalizedReportDataFromDb(task.id);
            getNormalizedReportData(task.salesCompanyId, task.id);
        }
    }, [task]);

    const getReportGridData = async (id) => {
        const response = await GetSalesCompanyTaskDetailsWithSproc(reportId);

        //parse grid data
        if (response.content) {
            let gridReportData = JSON.parse(response.content);

            //for backward compatibility for each point result add properties place_id and data_cid
            if (gridReportData.gridResponse && gridReportData.gridResponse.data) {
                gridReportData.gridResponse.data.forEach((keywordGridData) => {
                    if (keywordGridData && keywordGridData.points) {
                        keywordGridData.points.forEach((point) => {
                            if (point.results && point.results.length) {
                                point.results.forEach((pointResult) => {
                                    if (!pointResult.place_id && pointResult.placeId) {
                                        pointResult.place_id = pointResult.placeId;
                                    }

                                    if (!pointResult.data_cid && pointResult.dataCid) {
                                        pointResult.data_cid = pointResult.dataCid;
                                    }
                                });
                            }
                        });
                    }
                });
            }

            if (gridReportData) {
                setTaskGridData(gridReportData);

                setMapGridData({
                    googlePlaceId: gridReportData.googlePlaceId,
                    lat: response.lat,
                    lng: response.lng,
                    horizontalPoints: response.gridPoints,
                    verticalPoints: response.gridPoints,
                    ...(gridReportData.gridResponse && gridReportData.gridResponse.data ? gridReportData.gridResponse.data[0] : null),
                });

                if (gridReportData.gridResponse && gridReportData.gridResponse.data) {
                    let tempKeywords = gridReportData.gridResponse.data.map((x) => x.keyword.trim());

                    setGridKeywords(tempKeywords);

                    if (tempKeywords && tempKeywords.length) {
                        setSelectedKeyword(tempKeywords[0].trim());
                    }
                }
            } else {
                setIsLoadingMap(false);
            }
        } else {
            setIsLoadingMap(false);
        }
    };

    const getCompetitorsData = async (gridData, currentKeyword) => {
        if (gridData && gridData.gridResponse && gridData.gridResponse.data) {
            let tempCompetitorsDataForAllKeywords = [];
            let tempBusinessGridAverageData = [];

            gridData.gridResponse.data.forEach((keywordGridData) => {
                let tempCompetitorsData = [];
                let tempBusinessRankingData = {
                    average: 0,
                    top3Count: 0,
                    top10Count: 0,
                    top20Count: 0,
                    above20Count: 0,
                    positionTotal: 0,
                };

                //we need to attach opposite rankings in order to find most top rankings
                //i.e for ranking 1 we set 21, for 2 is 20..... for 21 is 0, so it's (21-position)
                if (keywordGridData && keywordGridData.points && keywordGridData.points.length) {
                    keywordGridData.points.forEach((point) => {
                        if (point.results && point.results.length) {
                            //calculate average grid ranking for business
                            let businessItem = point.results.find((x) => x.place_id === companyData.googlePlaceId);
                            if (businessItem) {
                                tempBusinessRankingData.positionTotal += businessItem.position;

                                if (businessItem.position > 0 && businessItem.position < 4) {
                                    tempBusinessRankingData.top3Count++;
                                } else if (businessItem.position > 3 && businessItem.position < 11) {
                                    tempBusinessRankingData.top10Count++;
                                } else if (businessItem.position > 10 && businessItem.position < 21) {
                                    tempBusinessRankingData.top20Count++;
                                } else {
                                    tempBusinessRankingData.above20Count++;
                                }
                            } else {
                                tempBusinessRankingData.positionTotal += 21;
                                tempBusinessRankingData.above20Count++;
                            }

                            //first get all distinct competitors
                            point.results.forEach((pointResult) => {
                                //skip current company results
                                if (
                                    pointResult.place_id !== companyData.googlePlaceId &&
                                    !tempCompetitorsData.some((comp) => comp.place_id === pointResult.place_id)
                                ) {
                                    pointResult.top3Count = 0;
                                    pointResult.top10Count = 0;
                                    pointResult.top20Count = 0;
                                    pointResult.above20Count = 0;
                                    pointResult.positionTotal = 0;
                                    pointResult.reviewsCount = 0;
                                    pointResult.reviewRating = 0;
                                    tempCompetitorsData.push(pointResult);
                                }
                            });
                        }
                    });

                    //get top3 and total sum of position rankings for each competitor
                    tempCompetitorsData.forEach((comp) => {
                        keywordGridData.points.forEach((point) => {
                            if (point.results && point.results.length) {
                                let compPointResult = point.results.find((x) => x.place_id === comp.place_id);

                                let rankingPosition = compPointResult ? compPointResult.position : 21;

                                comp.positionTotal += rankingPosition;

                                if (rankingPosition > 0 && rankingPosition < 4) {
                                    comp.top3Count++;
                                } else if (rankingPosition > 3 && rankingPosition < 11) {
                                    comp.top10Count++;
                                } else if (rankingPosition > 10 && rankingPosition < 21) {
                                    comp.top20Count++;
                                } else {
                                    comp.above20Count++;
                                }

                                if (compPointResult) {
                                    comp.reviewsCount = compPointResult.reviewsCount;
                                    comp.reviewRating = compPointResult.reviewRating;
                                }
                            }
                        });
                    });
                }

                let pointsNumber = keywordGridData.points.length;

                //business average ranking------
                tempBusinessRankingData.average = parseFloat(tempBusinessRankingData.positionTotal / pointsNumber).toFixed(1);

                tempBusinessGridAverageData.push({
                    keyword: keywordGridData.keyword.trim(),
                    ...tempBusinessRankingData,
                });
                setBusinessGridAverageData(tempBusinessGridAverageData);

                //competitors average ranking ---------
                tempCompetitorsData.forEach((comp) => {
                    comp.average = parseFloat(comp.positionTotal / pointsNumber).toFixed(1);
                });

                tempCompetitorsData = tempCompetitorsData.sort((a, b) => b.top3Count - a.top3Count);

                tempCompetitorsDataForAllKeywords.push({
                    keyword: keywordGridData.keyword.trim(),
                    competitorsData: tempCompetitorsData,
                });

                //set states for current keyword
                if (keywordGridData.keyword.trim() === currentKeyword.trim()) {
                    setCompetitorsData(tempCompetitorsData);
                }
            });

            //set business grid average by keyword
            if (selectedKeyword && tempBusinessGridAverageData && tempBusinessGridAverageData.length) {
                let tempBusinessGridAverageDataByKeyword = tempBusinessGridAverageData.find(
                    (x) => x.keyword.trim() === selectedKeyword.trim(),
                );
                if (tempBusinessGridAverageDataByKeyword) {
                    setBusinessGridAverageDataByKeyword(tempBusinessGridAverageDataByKeyword.average);
                    setSelectedCompanyRanking(tempBusinessGridAverageDataByKeyword);
                }
            }
        }
    };

    const getNormalizedReportData = async (id, reportName) => {
        setIsLoadingAuditData(true);

        let response = await GetNormalizedReportDataByCompanyId(id, reportName);

        if (response.success) {
            setAuditResponseData(response.data);

            if (response.data && response.data.length > 0 && response.data[0].businessData && response.data[0].businessData.inputData) {
                setSelectedIndustryCategory(response.data[0].businessData.inputData.industryCategoryId);
            }
        } else {
            setAuditResponseData();
        }

        setIsLoadingAuditData(false);
    };

    const getNormalizedReportDataFromDb = async (taskId) => {
        setIsLoadingAuditData(true);

        let response = await GetNormalizedReportDataByTaskIdFromDb(taskId);

        if (response.success) {
            if (response.data && response.data.length) {
                setAuditResponseData(response.data);
            }
        }

        setIsLoadingAuditData(false);
    };

    const getReportAnalizedSummaryData = async (reportName) => {
        //setIsLoadingSummaryData(true);

        let response = await GetReportAnalizedSummaryData(task.salesCompanyId, reportName);
        if (response.success && response.keywords && response.keywords.length) {
            if (response.keywords[0].messages && response.keywords[0].messages.length > 0) {
                let messages = response.keywords[0].messages;

                //sort by type, first Checklists
                messages = messages.sort((a, b) => a.type.localeCompare(b.type));

                let tempItemsProfile = messages.filter((x) => x.category && x.category === "Profile Settings");
                // tempItemsProfile = tempItemsProfile.sort((a, b) => a.name.localeCompare(b.name));
                setSummaryItemsForProfile(tempItemsProfile);

                let tempItemsProminence = messages.filter((x) => x.category && x.category === "Prominence");
                setSummaryItemsProminence(tempItemsProminence);

                let tempItemsReviews = messages.filter((x) => x.category && x.category === "Reviews");
                setSummaryItemsReviews(tempItemsReviews);
            }

            let tempSummaryItemsForKeywords = [];

            response.keywords.forEach((x) => {
                if (x.messages && x.messages.length) {
                    x.messages = x.messages.filter((message) => !["Profile Settings", "Prominence", "Reviews"].includes(message.category));

                    tempSummaryItemsForKeywords.push(x);
                }
            });

            setSummaryItemsForKeywords(tempSummaryItemsForKeywords);
            setSummaryData(response.keywords);
        } else {
            setSummaryData();
        }

        setIsLoadingSummaryData(false);
    };

    //get power citations and content websites for selected industry
    useEffect(() => {
        if (adminSettings && selectedIndustryCategory) {
            let category = adminSettings.industryCategories.find((x) => x.categoryGuid === selectedIndustryCategory);

            if (
                category &&
                category.websites &&
                category.websites.length &&
                adminSettings.powerWebsites &&
                adminSettings.powerWebsites.length
            ) {
                let tempCitationsWebsites = [];
                let tempContentWebsites = [];

                let allCitationsWebsites = adminSettings.powerWebsites.filter((x) => x.websiteIsCitations === true);
                if (allCitationsWebsites && allCitationsWebsites.length) {
                    allCitationsWebsites.forEach((website) => {
                        if (category.websites.includes(website.websiteGuid) && !tempCitationsWebsites.includes(website)) {
                            tempCitationsWebsites.push(website);
                        }
                    });
                }

                let allContentWebsites = adminSettings.powerWebsites.filter((x) => x.websiteIsContent === true);
                if (allContentWebsites && allContentWebsites.length) {
                    allContentWebsites.forEach((website) => {
                        if (category.websites.includes(website.websiteGuid) && !tempContentWebsites.includes(website)) {
                            tempContentWebsites.push(website);
                        }
                    });
                }

                setPowerCitationsWebsites(tempCitationsWebsites);
                setPowerContentWebsites(tempContentWebsites);
            }
        }
    }, [selectedIndustryCategory, adminSettings]);

    //get competitors data
    useEffect(() => {
        if (companyData && taskGridData) {
            getCompetitorsData(taskGridData, selectedKeyword);
            getReportAnalizedSummaryData(task.id);
        }
    }, [companyData, taskGridData]);

    //audit response data
    useEffect(() => {
        if (selectedKeyword && auditResponseData && auditResponseData.length) {
            let tempAuditResponseData = [...auditResponseData];

            //get data for selected keyword
            let tempAuditResponseKwData = tempAuditResponseData.find((x) => x.keyword.trim() === selectedKeyword.trim());

            if (tempAuditResponseKwData) {
                //build business and competitors data as array items to display data easier
                let tempAuditKeywordData = [];
                // tempAuditKeywordData.push(tempAuditResponseKwData.businessData);

                //for business data always use the first keyword
                //but for keyword relevance items use current keyword
                let businessData = {
                    // ...tempAuditResponseData[0].businessData,
                    ...tempAuditResponseKwData.businessData,
                    pageSEO: tempAuditResponseKwData.businessData.pageSEO,
                    keywordsIn: tempAuditResponseKwData.businessData.keywordsIn,
                    powerContent: tempAuditResponseKwData.businessData.powerContent,
                };

                console.log("businessData: ", businessData);
                // businessData.pageSEO = tempAuditResponseKwData.businessData.pageSEO;
                // businessData.keywordsIn = tempAuditResponseKwData.businessData.keywordsIn;
                // businessData.powerContent = tempAuditResponseKwData.businessData.powerContent;

                tempAuditKeywordData.push(businessData);

                if (tempAuditResponseKwData.competitorsData && tempAuditResponseKwData.competitorsData.length > 0) {
                    tempAuditResponseKwData.competitorsData.map((comp) => {
                        tempAuditKeywordData.push(comp);
                    });
                }

                //set minimal timeout to see the spinner
                setIsLoadingAuditData(true);
                setTimeout(function () {
                    setAuditKeywordData(tempAuditKeywordData);
                    setIsLoadingAuditData(false);
                }, 200);
            }
        }
    }, [auditResponseData, selectedKeyword]);

    //get rating for business
    useEffect(() => {
        if (companyData && auditResponseData && auditResponseData.length) {
            let tempAuditResponseData = [...auditResponseData];

            //get rating for business
            if (
                tempAuditResponseData[0].businessData &&
                tempAuditResponseData[0].businessData.profile &&
                tempAuditResponseData[0].businessData.profile.rating &&
                companyData
            ) {
                setBusinessRatingData({
                    reviewsCount: tempAuditResponseData[0].businessData.profile.rating.votesCount,
                    reviewRating: tempAuditResponseData[0].businessData.profile.rating.value,
                });
            }
        }
    }, [auditResponseData, companyData]);

    const handleSelectKeyword = (keywordName) => {
        setSelectedKeyword(keywordName);
    };

    //handle selected keyword
    useEffect(() => {
        if (selectedKeyword && taskGridData) {
            storeScrollPosition();

            let tempSelectedTaskGridData = { ...taskGridData };

            let tempGridData = tempSelectedTaskGridData.gridResponse.data.filter(
                (k) => k.keyword.trim().toLowerCase() === selectedKeyword.trim().toLowerCase(),
            );

            setMapGridData({
                googlePlaceId: tempSelectedTaskGridData.googlePlaceId,
                lat: tempSelectedTaskGridData.gridResponse.lat,
                lng: tempSelectedTaskGridData.gridResponse.lng,
                horizontalPoints: tempSelectedTaskGridData.gridResponse.horizontalPoints,
                verticalPoints: tempSelectedTaskGridData.gridResponse.verticalPoints,
                ...(tempGridData && tempGridData.length ? tempGridData[0] : null),
            });

            getCompetitorsData(taskGridData, selectedKeyword);
            getReportAnalizedSummaryData(task.id);

            //set business grid average
            if (businessGridAverageData && businessGridAverageData.length) {
                let tempBusinessGridAverageDataByKeyword = businessGridAverageData.find((x) => x.keyword.trim() === selectedKeyword.trim());
                if (tempBusinessGridAverageDataByKeyword) {
                    setBusinessGridAverageDataByKeyword(tempBusinessGridAverageDataByKeyword.average);
                }
            }

            setSelectedCompetitorOnMap();
            //handleScrollPosition();
        }
    }, [selectedKeyword]);

    const handleSelectCompetitorOnMap = (competitor) => {
        if (competitor) {
            setSelectedCompetitorOnMap(competitor);

            setSelectedCompanyRanking({
                average: competitor.average,
                top3Count: competitor.top3Count,
                top10Count: competitor.top10Count,
                top20Count: competitor.top20Count,
                above20Count: competitor.above20Count,
            });
        } else {
            setSelectedCompanyRanking(businessGridAverageDataByKeyword);
        }
    };

    const handleSelectCompetitorOnMapMobile = (competitorPlaceId) => {
        if (competitorsData) {
            let competitor = competitorsData.find((x) => x.place_id === competitorPlaceId);

            if (competitor) {
                setSelectedCompetitorOnMap(competitor);

                setSelectedCompanyRanking({
                    average: competitor.average,
                    top3Count: competitor.top3Count,
                    top10Count: competitor.top10Count,
                    top20Count: competitor.top20Count,
                    above20Count: competitor.above20Count,
                });
            }
        }
    };

    const printJsonNodeValue = (dataIndex, setting) => {
        let output = "";

        let propName = setting.propName;
        let printPropName = setting.printPropName;
        let label = setting.label;
        let shouldTruncate = setting.shouldTruncate;
        let shouldHighlightText = setting.highlightText;

        if (auditKeywordData) {
            if (propName === "socialProfiles") {
                printSocialProfilesList(dataIndex);
                return;
            } else if (propName === "totalPhotos") {
                //don't open print dialog
                return;
            } else if (printPropName) {
                if (printPropName === "reviews") {
                    printReviewsList(dataIndex, "total", shouldHighlightText);
                    return;
                } else if (printPropName === "reviews.last20") {
                    printReviewsList(dataIndex, "last20", null, shouldHighlightText);
                    return;
                } else if (printPropName === "workTime") {
                    printWorkHours(dataIndex);
                    return;
                } else if (printPropName === "posts") {
                    printPostsList(dataIndex, shouldHighlightText);
                    return;
                } else if (printPropName === "qa") {
                    printQAList(dataIndex, shouldHighlightText);
                    return;
                } else if (
                    printPropName.indexOf("citations") > -1 ||
                    printPropName.indexOf("powerCitations") > -1 ||
                    printPropName.indexOf("powerContent") > -1 ||
                    printPropName.indexOf("indexedPages") > -1
                ) {
                    printCitationsList(dataIndex, printPropName, shouldHighlightText);
                    return;
                }
            }

            let foundNodeValue;
            let prinPropNameArgs = [];

            if (printPropName) {
                prinPropNameArgs = printPropName.indexOf(".") > -1 ? printPropName.split(".") : [printPropName];
            }

            if (prinPropNameArgs && prinPropNameArgs.length === 1) {
                foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]];
            } else if (prinPropNameArgs && prinPropNameArgs.length === 2) {
                foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]];
            } else if (prinPropNameArgs && prinPropNameArgs.length === 3) {
                foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]][prinPropNameArgs[2]];
            }

            if (label) {
                output += `<h4 class="json-output-title mb-3">${label}</h4>`;
            }

            if (foundNodeValue) {
                if (Array.isArray(foundNodeValue)) {
                    foundNodeValue.map((value, index) => {
                        if (typeof value === "object") {
                            output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';
                            output += outputObjectAsHtml(value, index, 0, shouldTruncate);
                            output += "</div>";
                        } else {
                            output += outputValueAsHtml(value, index, shouldTruncate, shouldHighlightText);
                        }
                    });
                } else if (typeof foundNodeValue === "object") {
                    output += outputObjectAsHtml(foundNodeValue, null, 0, shouldTruncate);
                } else {
                    output += outputValueAsHtml(foundNodeValue, null, shouldTruncate, shouldHighlightText);
                }
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const outputObjectAsHtml = (objectValue, arrayIndex = null, nestingLevel = 0, shouldTruncate = true) => {
        let output = "";

        Object.keys(objectValue).map((key, objectIndex) => {
            let parsedItemValue;

            if (objectValue[key]) {
                if (typeof objectValue[key] === "object") {
                    output += outputObjectAsHtml(objectValue[key], null, nestingLevel++, shouldTruncate);
                } else {
                    parsedItemValue = objectValue[key];
                }

                if (parsedItemValue === true) {
                    parsedItemValue = "Yes";
                } else if (parsedItemValue === false) {
                    parsedItemValue = "No";
                }

                let textTruncate = shouldTruncate ? "text-truncate" : "";

                output += `<div class="col-12 json-output-object-item" key="${objectIndex}">`;
                output += `<label class="form-label json-output-object-item-label" title="${key}"><strong>${
                    arrayIndex !== null && objectIndex === 0 ? `<span>${arrayIndex + 1}. </span>` : ""
                }<span>${key}:</span></strong></label>`;

                if (typeof parsedItemValue === "string") {
                    if (parsedItemValue.indexOf("https://") > -1 || parsedItemValue.indexOf("http://") > -1) {
                        output += `<a class="btn btn-link p-0 json-output-object-item-value ${textTruncate}" title="${parsedItemValue}" target="_blank" href="${parsedItemValue}">${parsedItemValue}</a>`;
                    } else {
                        output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}">${parsedItemValue}</label>`;
                    }
                } else {
                    if (typeof parsedItemValue === "object") {
                        output += `<div class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}" dangerouslySetInnerHTML="${parsedItemValue}"></div>`;
                    } else {
                        output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}">${parsedItemValue}</label>`;
                    }
                }

                output += `</div>`;
            }
        });

        return output;
    };

    const outputValueAsHtml = (value, arrayIndex = null, shouldTruncate = true, shouldHighlightText = false) => {
        let output = "";
        let ordinal = arrayIndex !== null ? `<span>${arrayIndex + 1}. </span>` : "";
        let textTruncate = shouldTruncate ? "text-truncate" : "";
        let titleValue = value;

        if (shouldHighlightText && selectedKeyword) {
            value = getHighlightedText(value, selectedKeyword);
        }

        if (typeof value === "string") {
            if (value.indexOf("https://") > -1 || value.indexOf("http://") > -1) {
                output += `<a class="btn btn-link py-0 json-output-object-item-value ${textTruncate}" title="${titleValue}" target="_blank" href="${value}">${ordinal}${value}</a>`;
            } else {
                output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${titleValue}">${ordinal}${value}</label>`;
            }
        } else {
            output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${titleValue}">${ordinal}${value}</label>`;
        }

        return output;
    };

    const printReviewsList = (dataIndex, reviewsType, subType = null, shouldHighlightText = false) => {
        let output = "";

        let reviewsTitle = "Reviews";

        switch (reviewsType) {
            case "last30Days":
                reviewsTitle = "Reviews in the last 30 days";
                break;
            case "last20":
                reviewsTitle = "Last 20 Reviews";
                break;
            case "mostRelevant":
                reviewsTitle = "Most Relevant Reviews";
                break;
            case "total":
                reviewsTitle = "Reviews";
                break;
        }

        output += `<h4 class="json-output-title mb-3">${reviewsTitle}</h4>`;

        if (auditKeywordData && auditKeywordData[dataIndex] && auditKeywordData[dataIndex].reviews) {
            let reviews;

            if (reviewsType === "total") {
                //merge last 20. last 30 days and most relevant reviews
                let reviewsLast30Days = [];
                let reviewsLast20 = [];
                let reviewsMostRelevant = [];

                if (auditKeywordData[dataIndex].reviews.last30Days && auditKeywordData[dataIndex].reviews.last30Days.results) {
                    reviewsLast30Days = auditKeywordData[dataIndex].reviews.last30Days.results;
                }

                if (auditKeywordData[dataIndex].reviews.last20 && auditKeywordData[dataIndex].reviews.last20.results) {
                    reviewsLast20 = auditKeywordData[dataIndex].reviews.last20.results;
                }

                if (auditKeywordData[dataIndex].reviews.mostRelevant && auditKeywordData[dataIndex].reviews.mostRelevant.results) {
                    reviewsMostRelevant = auditKeywordData[dataIndex].reviews.mostRelevant.results;
                }

                let tempMergedReviews = reviewsLast30Days.concat(
                    reviewsLast20.filter((item2) => !reviewsLast30Days.some((item1) => item1.reviewId === item2.reviewId)),
                );

                reviews = tempMergedReviews.concat(
                    reviewsMostRelevant.filter((item2) => !tempMergedReviews.some((item1) => item1.reviewId === item2.reviewId)),
                );
            } else {
                reviews = auditKeywordData[dataIndex].reviews[reviewsType].results;
            }

            if (reviews && reviews.length > 0) {
                //filter by subtype
                if (subType) {
                    if (reviewsType === "last30Days") {
                        switch (subType) {
                            case "last30HaveReplies":
                                reviews = reviews.filter((x) => x.answer !== null);
                                break;
                            case "last30DoNotHaveReplies":
                                reviews = reviews.filter((x) => x.answer === null);
                                break;
                            case "last30LocalGuideReviews":
                                reviews = reviews.filter((x) => x.user !== null && x.user.localGuide === true);
                                break;
                            case "last30NegativeReviews":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3);
                                break;
                            case "last30NegativeReviewsHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer !== null);
                            case "last30NegativeReviewsDoNotHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer === null);
                                break;
                        }
                    } else if (reviewsType === "last20") {
                        switch (subType) {
                            case "last20HaveReplies":
                                reviews = reviews.filter((x) => x.answer !== null);
                                break;
                            case "last20DoNotHaveReplies":
                                reviews = reviews.filter((x) => x.answer === null);
                                break;
                            case "last20LocalGuideReviews":
                                reviews = reviews.filter((x) => x.user !== null && x.user.localGuide === true);
                                break;
                            case "last20NegativeReviews":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3);
                                break;
                            case "last20NegativeReviewsHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer !== null);
                            case "last20NegativeReviewsDoNotHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer === null);
                                break;
                        }
                    }
                }

                //if it is keyword relevance section, filter by keyword
                if (shouldHighlightText && selectedKeyword) {
                    reviews = reviews.filter((review) => {
                        let reviewText = review.text || review.snippet;

                        return reviewText ? reviewText.toLowerCase().indexOf(selectedKeyword.toLowerCase()) > -1 : false;
                    });
                }

                let truncateText = shouldHighlightText && selectedKeyword ? "" : "text-truncate";

                reviews.map((review, index) => {
                    if (typeof review === "object") {
                        output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                        //user
                        if (review.user && review.user.name) {
                            output += `<div class="form-label json-output-object-item-value ${truncateText}" title="${
                                review.user.name
                            }"><strong><span>${index + 1}. </span></strong>${review.user.name}`;

                            if (review.user.localGuide === true) {
                                output += `<span class="ms-3">(local guide)</span>`;
                            }
                            output += "</div>";
                        }

                        //rating
                        if (review.rating && parseInt(review.rating)) {
                            let ratingStarsHtml = "";
                            let rating = parseInt(review.rating);
                            for (let i = 0; i < rating; i++) {
                                ratingStarsHtml += `<i class="fa-solid fa-star me-1"></i>`;
                            }

                            if (rating < 5) {
                                for (let i = rating; i < 5; i++) {
                                    ratingStarsHtml += `<i class="fa-regular fa-star text-muted opacity-50 me-1"></i>`;
                                }
                            }

                            output += `<div class="form-label json-output-object-item-value ${truncateText} small-size mb-2">${ratingStarsHtml}`;

                            //date
                            if (review.lastEditOfDate) {
                                output += `<span class="ms-3">${`${moment(review.lastEditOfDate).format(
                                    "DD/MM/YYYY",
                                )} (${review.dateString})`}</span>`;
                            }

                            output += `</div>`;
                        }

                        //text
                        let reviewText = review.text || review.snippet;
                        let reviewTextForTitle = reviewText;
                        if (reviewText) {
                            if (shouldHighlightText && selectedKeyword) {
                                reviewText = getHighlightedText(reviewText, selectedKeyword);
                            }

                            output += `<div class="json-output-object-item">`;
                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${reviewTextForTitle}">${reviewText}</label>`;
                            output += "</div>";
                        }

                        //answer
                        if (review.answer) {
                            let answerText = review.answer.text || review.answer.text;
                            let answerTextForTitle = answerText;

                            if (shouldHighlightText && selectedKeyword) {
                                answerText = getHighlightedText(answerText, selectedKeyword);
                            }

                            output += `<div class="json-output-object-item">`;
                            output += '<div class="review-answer border-start">';
                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100"><strong>Response:</strong>`;

                            //date
                            if (review.answer.lastEditOfAnswerDate) {
                                output += `<span class="ms-3 small-size">${`${moment(review.answer.lastEditOfAnswerDate).format(
                                    "DD/MM/YYYY",
                                )} (${review.answer.answerDateString})`}</span>`;
                            }
                            output += "</label>";

                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${answerTextForTitle}">${answerText}</label>`;
                            output += "</div>";
                            output += "</div>";
                        }

                        output += "</div>";
                    }
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printSocialProfilesList = (dataIndex) => {
        let output = "";

        let title = "Social Profiles";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (
            auditKeywordData &&
            auditKeywordData[dataIndex] &&
            auditKeywordData[dataIndex].profile &&
            auditKeywordData[dataIndex].profile.socialProfiles
        ) {
            let items = auditKeywordData[dataIndex].profile.socialProfiles;

            if (items && items.length > 0) {
                items.map((item, index) => {
                    output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                    //name
                    if (item.name) {
                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<span>${index + 1}. </span>${item.name}`;
                        output += "</div>";
                    }

                    //link
                    if (item.link) {
                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<a class="btn btn-link p-0 json-output-object-item-value text-truncate" title="${item.link}" href="${item.link}" target="_blank">${item.link}</a>`;
                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printPostsList = (dataIndex, shouldHighlightText = false) => {
        let output = "";

        let title = "Posts";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (
            auditKeywordData &&
            auditKeywordData[dataIndex] &&
            auditKeywordData[dataIndex].posts &&
            auditKeywordData[dataIndex].posts.results
        ) {
            let items = auditKeywordData[dataIndex].posts.results;

            if (items && items.length > 0) {
                //if it is keyword relevance section, filter by keyword
                if (shouldHighlightText && selectedKeyword) {
                    items = items.filter((item) => {
                        return item.postText ? item.postText.toLowerCase().indexOf(selectedKeyword.toLowerCase()) > -1 : false;
                    });
                }

                let truncateText = shouldHighlightText && selectedKeyword ? "" : "text-truncate";

                items.map((item, index) => {
                    output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                    // //author
                    // if (item.author) {
                    // 	output += `<div class="form-label json-output-object-item-value ${truncateText}">`;
                    // 	output += `<span>${index + 1}. </span>${item.author}`;
                    // 	output += '</div>';
                    // }

                    //date
                    if (item.postDateValue) {
                        output += `<div class="form-label json-output-object-item-value ${truncateText}">`;
                        output += `<span>${index + 1}. </span><span>${moment(item.postDateValue).format("DD/MM/YYYY")}`;
                        output += "</div>";
                    }

                    //text
                    if (item.postText) {
                        let textFortitle = item.postText;

                        if (shouldHighlightText && selectedKeyword) {
                            item.postText = getHighlightedText(item.postText, selectedKeyword);
                        }

                        output += `<div class="form-label json-output-object-item-value ${truncateText}">`;
                        output += `<label class="json-output-object-item-value ${truncateText}" title="${textFortitle}">${item.postText}</label>`;
                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printQAList = (dataIndex, shouldHighlightText = false) => {
        let output = "";

        let title = "Questions & Answers";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (auditKeywordData && auditKeywordData[dataIndex] && auditKeywordData[dataIndex].qa && auditKeywordData[dataIndex].qa.results) {
            let items = auditKeywordData[dataIndex].qa.results;

            if (items && items.length > 0) {
                //if it is keyword relevance section, filter by keyword
                if (shouldHighlightText && selectedKeyword) {
                    items = items.filter((item) => {
                        return item.questionText ? item.questionText.toLowerCase().indexOf(selectedKeyword.toLowerCase()) > -1 : false;
                    });
                }

                let truncateText = shouldHighlightText && selectedKeyword ? "" : "text-truncate";

                items.map((item, index) => {
                    output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                    //user
                    if (item.profileName) {
                        output += `<div class="form-label json-output-object-item-value ${truncateText}" title="${item.profileName}"><span>${
                            index + 1
                        }. </span>${item.profileName}`;

                        output += "</div>";
                    }

                    //date
                    if (item.dateCreated) {
                        output += `<div class="form-label json-output-object-item-value small-size ${truncateText} ms-3 mb-1">`;
                        output += `<span>${moment(item.dateCreated).format("DD/MM/YYYY")}</span>`;
                        output += `<span class="ms-3">(${item.timeAgo})</span>`;
                        output += "</div>";
                    }

                    //text
                    if (item.questionText) {
                        let textForTitle = item.questionText;

                        if (shouldHighlightText && selectedKeyword) {
                            item.questionText = getHighlightedText(item.questionText, selectedKeyword);
                        }

                        output += `<div class="json-output-object-item">`;
                        output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${textForTitle}">${item.questionText}</label>`;
                        output += "</div>";
                    }

                    //answers
                    if (item.items) {
                        output += '<div class="qa-answers-wrapper border-start">';

                        item.items.forEach((answer) => {
                            //user
                            if (answer.profileName) {
                                output += `<div class="form-label json-output-object-item-value ${truncateText}" title="${answer.profileName}">${answer.profileName}</div>`;
                            }

                            if (answer.timestamp) {
                                output += `<div class="form-label json-output-object-item-value small-size ${truncateText} mb-1">`;
                                output += `<span>${moment(answer.timestamp).format("DD/MM/YYYY")}</span>`;
                                output += `<span class="ms-3">(${answer.timeAgo})</span>`;
                                output += "</div>";
                            }

                            let textForTitle = answer.answerText;

                            if (shouldHighlightText && selectedKeyword) {
                                answer.answerText = getHighlightedText(answer.answerText, selectedKeyword);
                            }

                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${textForTitle}">${answer.answerText}</label>`;
                            output += "</div>";
                            output += "</div>";
                        });

                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printWorkHours = (dataIndex) => {
        let output = "";

        let title = "Business Hours";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (
            auditKeywordData &&
            auditKeywordData[dataIndex] &&
            auditKeywordData[dataIndex].profile &&
            auditKeywordData[dataIndex].profile.workTime &&
            auditKeywordData[dataIndex].profile.workTime.data &&
            auditKeywordData[dataIndex].profile.workTime.data.timetable
        ) {
            let days = auditKeywordData[dataIndex].profile.workTime.data.timetable;

            if (days) {
                Object.keys(days).map((key, index) => {
                    let hoursStr = "";
                    output += `<div class="row json-output-array-item mb-1" key="${index}">`;
                    output += `<label class="form-label json-output-object-item-label">${capitalize(key)}:</label>`;

                    if (days[key] && Array.isArray(days[key]) && days[key].length > 0) {
                        let dayObj = days[key][0];

                        if (dayObj) {
                            if (dayObj.open && dayObj.open.hour !== null) {
                                let openStr = dayObj.open.hour;

                                if (dayObj.open.minute !== null) {
                                    openStr += ":" + (parseInt(dayObj.open.minute) === 0 ? "00" : dayObj.open.minute);
                                }

                                if (openStr) {
                                    //hoursStr += moment(openStr, [ 'h:mm A' ]).format('HH:mm');
                                    hoursStr += moment(openStr, "HH:mm").format("h:mm A");
                                }
                            }

                            if (dayObj.close && dayObj.close.hour !== null) {
                                let closeStr = dayObj.close.hour;

                                if (dayObj.close.minute !== null) {
                                    closeStr += ":" + (parseInt(dayObj.close.minute) === 0 ? "00" : dayObj.close.minute);
                                }

                                if (closeStr) {
                                    hoursStr += " - " + moment(closeStr, "HH:mm").format("h:mm A");
                                }
                            }
                        }
                    } else {
                        hoursStr = "Closed";
                    }

                    output += `<label class="form-label json-output-object-item-value w-auto">${hoursStr}</label>`;
                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printCitationsList = (dataIndex, printPropName, shouldHighlightText = false) => {
        let output = "";

        let title = "";
        let prinPropNameArgs = [];

        if (printPropName) {
            prinPropNameArgs = printPropName.indexOf(".") > -1 ? printPropName.split(".") : [printPropName];

            if (printPropName.indexOf("powerContent") > -1) {
                title = "Power Content";
            } else if (printPropName.indexOf("powerCitations") > -1) {
                title = "Power Citations";
            } else if (printPropName.indexOf("citations") > -1) {
                title = "Citations";
            } else if (printPropName.indexOf("indexedPages") > -1) {
                title = "Indexed Pages";
            }
        }

        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (auditKeywordData && auditKeywordData[dataIndex]) {
            let results;

            if (prinPropNameArgs && prinPropNameArgs.length === 2) {
                if (prinPropNameArgs[1] === "results") {
                    results = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]];
                } else {
                    let items = auditKeywordData[dataIndex][prinPropNameArgs[0]].find(
                        (x) => x.website.indexOf(prinPropNameArgs[1].replace("__", ".")) > -1,
                    );

                    if (items && items.results) {
                        results = items.results;
                    }
                }
            }

            if (results && results.length > 0) {
                results.map((item, index) => {
                    output += `<div class="json-output-array-item mb-2 py-2 border-bottom" key="${index}">`;

                    //title
                    if (item.title) {
                        if (shouldHighlightText && selectedKeyword) {
                            item.title = getHighlightedText(item.title, selectedKeyword);
                        }

                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<span>${index + 1}. </span>${item.title}`;
                        output += "</div>";
                    }

                    //link
                    if (item.link) {
                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<a class="btn btn-link p-0 json-output-object-item-value text-truncate" title="${item.link}" href="${item.link}" target="_blank">${item.link}</a>`;
                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const toggleJsonOutputDialog = async (e) => {
        setShowJsonOutputDialog(!showJsonOutputDialog);

        if (showJsonOutputDialog) {
            setJsonOutput();
        }

        if (e) e.preventDefault();
    };

    //store scroll position on audit table
    useEffect(() => {
        if (auditKeywordData && auditKeywordData.length > 0) {
            handleScrollPosition();
        }
    }, [auditKeywordData]);

    const handleScrollPosition = () => {
        const scrollPosition = sessionStorage.getItem("auditScrollPosition");
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition));
            sessionStorage.removeItem("auditScrollPosition");
        }
    };

    const storeScrollPosition = () => {
        if (window.pageYOffset !== 0) {
            sessionStorage.setItem("auditScrollPosition", window.pageYOffset);
        }
    };

    return (
        <div className={`public-view-audit-report-container container-fluid`}>
            <div className={`container`}>
                <div className={`main-content-inner-container`}>
                    {isLoadingTask ? (
                        <div>
                            <Spinner className={"small"} />
                        </div>
                    ) : (
                        <Fragment>
                            {task && (
                                <div className="header-wrapper">
                                    <div className="task-details-wrapper">
                                        <div className="company-name text-start">{`${task.salesCompanyName}${
                                            task.location ? ` ${task.location}` : ""
                                        }`}</div>
                                        <div className="created-date">{`${moment(task.dateCreated).format("MMMM DD, YYYY")}`}</div>
                                    </div>
                                </div>
                            )}
                        </Fragment>
                    )}

                    <ul className="nav nav-tabs nav-fill" id="tabReport" role="tablist">
                        <li className="nav-item" role="presentation" key="summary">
                            <button
                                className={`nav-link ${currentReportTab === "summary" ? "active" : ""}`}
                                type="button"
                                onClick={() => setCurrentReportTab("summary")}
                            >
                                <div className="tab-button summary">
                                    <div className="tab-button-icon">
                                        <i className="fa-solid fa-clipboard-check" />
                                    </div>
                                    <div className="tab-button-text">
                                        <div className="tab-button-title">Summary & Checklist</div>
                                        <div className="tab-button-subtitle">
                                            A summary and checklist of things you can do to boost your rankings
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </li>
                        <li className="nav-item" role="presentation" key="grid">
                            <button
                                className={`nav-link ${currentReportTab === "grid" ? "active" : ""}`}
                                type="button"
                                onClick={() => setCurrentReportTab("grid")}
                            >
                                <div className="tab-button grid">
                                    <div className="tab-button-icon">
                                        <i className="fa-solid fa-map-location-dot" />
                                    </div>
                                    <div className="tab-button-text">
                                        <div className="tab-button-title">Geo Grid Report</div>
                                        <div className="tab-button-subtitle">
                                            See where you and your competitors profiles are ranking in Google Maps
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </li>
                        <li className="nav-item" role="presentation" key="seo">
                            <button
                                className={`nav-link ${currentReportTab === "seo" ? "active" : ""}`}
                                type="button"
                                onClick={() => setCurrentReportTab("seo")}
                            >
                                <div className="tab-button seo">
                                    <div className="tab-button-icon">
                                        <i className="fa-solid fa-chart-column" />
                                    </div>
                                    <div className="tab-button-text">
                                        <div className="tab-button-title">Local SEO & Competition</div>
                                        <div className="tab-button-subtitle">
                                            See how your local SEO compares to your top 3 competitors in Google Search
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </li>
                    </ul>
                    <div className={`tab-content ${currentReportTab}`} id="tabReportContent">
                        {currentReportTab === "summary" && (
                            <div className={`tab-pane fade position-relative ${currentReportTab === "summary" ? "show active" : ""}`}>
                                <div className="summary-data-container">
                                    <div className="info-panel">
                                        <div className="title">Summary & Checklist</div>
                                        <div className="subtitle">
                                            The report bellow is the result of scanning your Google Business Profile and local SEO content,
                                            then we compare it to your top 3 competitors from our Geo Grid Report. Bellow you will see our
                                            analysis result and recommendations to boost your profile rankings.
                                        </div>
                                    </div>

                                    {isLoadingSummaryData && (
                                        <div className="text-center">
                                            <Spinner />
                                        </div>
                                    )}

                                    {!isLoadingSummaryData && (
                                        <Fragment>
                                            {/* profile settings */}
                                            {summaryItemsForProfile && summaryItemsForProfile.length > 0 && (
                                                <div className="panel-wrapper">
                                                    <div className="summary-panel-title">{summaryItemsForProfile[0].category}</div>
                                                    <div className="summary-panel-subtitle">
                                                        The following items are optimization you can make to your Google business profile
                                                    </div>
                                                    {summaryItemsForProfile.map((item, index) => (
                                                        <Fragment key={index}>
                                                            {item && (
                                                                <div
                                                                    className={`message-item ${
                                                                        item.type === "Checklist" ? "checklist" : "competition"
                                                                    }`}
                                                                    key={index}
                                                                >
                                                                    <div className="icon">
                                                                        {item.type === "Checklist" ? (
                                                                            <i className="fa-solid fa-square-check" />
                                                                        ) : (
                                                                            <i className="fa-solid fa-chart-column" />
                                                                        )}
                                                                    </div>
                                                                    <div className="message-body">
                                                                        {item.niceName && <div className="nice-name">{item.niceName}</div>}
                                                                        {item.message && <div className="text">{item.message}</div>}
                                                                        {item.recommendation && item.recommendation.trim() !== "" && (
                                                                            <div className="recommendation">{item.recommendation}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            )}

                                            {/* keyword relevance */}
                                            {summaryItemsForKeywords && summaryItemsForKeywords.length > 0 && (
                                                <div className="panel-wrapper">
                                                    <div className="summary-panel-title">Keyword Relevance</div>
                                                    <div className="summary-panel-subtitle">
                                                        Relevance refers to how well a local Business Profile matches what someone is
                                                        searching for. The following items are optimizations that can be made to your Google
                                                        Profile, website or social media content increase your keyword relevance score.
                                                    </div>
                                                    {summaryItemsForKeywords.map((keywordData, index) => (
                                                        <div className="summary-keyword-panel" key={index}>
                                                            <div className="summary-keyword-item">
                                                                <span className="keyword-label">Keyword:</span>
                                                                <span className="keyword-value">{keywordData.keyword}</span>
                                                            </div>

                                                            {keywordData.messages && keywordData.messages.length > 0 && (
                                                                <Fragment>
                                                                    {keywordData.messages.map((item, messageIndex) => (
                                                                        <Fragment key={messageIndex}>
                                                                            {item && (
                                                                                <div
                                                                                    className={`message-item ${
                                                                                        item.type === "Checklist"
                                                                                            ? "checklist"
                                                                                            : "competition"
                                                                                    }`}
                                                                                    key={`${index}_${messageIndex}`}
                                                                                >
                                                                                    <div className="icon">
                                                                                        {item.type === "Checklist" ? (
                                                                                            <i className="fa-solid fa-square-check" />
                                                                                        ) : (
                                                                                            <i className="fa-solid fa-chart-column" />
                                                                                        )}
                                                                                    </div>
                                                                                    <div className="message-body">
                                                                                        {item.niceName && (
                                                                                            <div className="nice-name">{item.niceName}</div>
                                                                                        )}
                                                                                        {item.message && (
                                                                                            <div className="text">{item.message}</div>
                                                                                        )}
                                                                                        {item.recommendation &&
                                                                                            item.recommendation.trim() !== "" && (
                                                                                                <div className="recommendation">
                                                                                                    {item.recommendation}
                                                                                                </div>
                                                                                            )}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </Fragment>
                                                                    ))}
                                                                </Fragment>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* prominence */}
                                            {summaryItemsProminence && summaryItemsProminence.length > 0 && (
                                                <div className="panel-wrapper">
                                                    <div className="summary-panel-title">{summaryItemsProminence[0].category}</div>
                                                    <div className="summary-panel-subtitle">
                                                        The following items are optimization you can make to your Google business profile
                                                    </div>
                                                    {summaryItemsProminence.map((item, index) => (
                                                        <Fragment key={index}>
                                                            {item && (
                                                                <div
                                                                    className={`message-item ${
                                                                        item.type === "Checklist" ? "checklist" : "competition"
                                                                    }`}
                                                                    key={index}
                                                                >
                                                                    <div className="icon">
                                                                        {item.type === "Checklist" ? (
                                                                            <i className="fa-solid fa-square-check" />
                                                                        ) : (
                                                                            <i className="fa-solid fa-chart-column" />
                                                                        )}
                                                                    </div>
                                                                    <div className="message-body">
                                                                        {item.niceName && <div className="nice-name">{item.niceName}</div>}
                                                                        {item.message && <div className="text">{item.message}</div>}
                                                                        {item.recommendation && item.recommendation.trim() !== "" && (
                                                                            <div className="recommendation">{item.recommendation}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            )}

                                            {/* reviews */}
                                            {summaryItemsReviews && summaryItemsReviews.length > 0 && (
                                                <div className="panel-wrapper">
                                                    <div className="summary-panel-title">{summaryItemsReviews[0].category}</div>
                                                    <div className="summary-panel-subtitle">
                                                        The following items are optimization you can make to your Google business profile
                                                    </div>
                                                    {summaryItemsReviews.map((item, index) => (
                                                        <Fragment key={index}>
                                                            {item && (
                                                                <div
                                                                    className={`message-item ${
                                                                        item.type === "Checklist" ? "checklist" : "competition"
                                                                    }`}
                                                                    key={index}
                                                                >
                                                                    <div className="icon">
                                                                        {item.type === "Checklist" ? (
                                                                            <i className="fa-solid fa-square-check" />
                                                                        ) : (
                                                                            <i className="fa-solid fa-chart-column" />
                                                                        )}
                                                                    </div>
                                                                    <div className="message-body">
                                                                        {item.niceName && <div className="nice-name">{item.niceName}</div>}
                                                                        {item.message && <div className="text">{item.message}</div>}
                                                                        {item.recommendation && item.recommendation.trim() !== "" && (
                                                                            <div className="recommendation">{item.recommendation}</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        )}

                        {currentReportTab === "grid" && (
                            <div className={`tab-pane fade position-relative ${currentReportTab === "grid" ? "show active" : ""}`}>
                                <div className="info-panel">
                                    <div className="title">Profile Ranking Grid Report</div>
                                    <div className="subtitle">
                                        The grid report shows you and your competitors Google Profile rak position at each of the latitude
                                        and longitude points on the map if you were at that location and searched for "Realtor".
                                    </div>
                                </div>

                                {gridKeywords && gridKeywords.length > 0 && (
                                    <div className="panel-wrapper">
                                        {gridKeywords.map((keywordName, index) => (
                                            <button
                                                className={`btn panel-report${
                                                    selectedKeyword && selectedKeyword === keywordName ? " active" : ""
                                                } me-2`}
                                                onClick={() => handleSelectKeyword(keywordName)}
                                                disabled={isLoadingTask}
                                                key={index}
                                            >
                                                {keywordName}
                                            </button>
                                        ))}
                                    </div>
                                )}

                                <div className="public-grid-map-container">
                                    <Fragment>
                                        {mapGridData && (
                                            <Fragment>
                                                <div className="panel-wrapper map-inner-container">
                                                    <div className="map-keyword">
                                                        <span className="keyword-label">Keyword:</span>
                                                        <span className="keyword-value">{selectedKeyword}</span>
                                                    </div>

                                                    {selectedCompanyRanking && (
                                                        <Fragment>
                                                            <div className="map-rankings-wrapper">
                                                                {rankingsTypes.map((rankingType, index) => {
                                                                    return (
                                                                        <div className="map-ranking panel-report" key={index}>
                                                                            <div className="ranking-label">{rankingType.label}</div>
                                                                            <div className="ranking-value">
                                                                                {selectedCompanyRanking[rankingType.value]}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </Fragment>
                                                    )}

                                                    <div className="map-wrapper">
                                                        <GridMapV5
                                                            key="map-0"
                                                            mapIdValue="report-map-0"
                                                            gridData={mapGridData}
                                                            placeId={mapGridData.googlePlaceId}
                                                            isFullHeight={true}
                                                            reportSettings={reportSettings}
                                                            selectedCompetitor={selectedCompetitorOnMap}
                                                        />
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="map-side-panel business">
                                                        {/* add business details first */}
                                                        {companyData && (
                                                            <div
                                                                className={`panel-wrapper panel-report competitor-item ${
                                                                    !selectedCompetitorOnMap ? "active" : ""
                                                                }`}
                                                                onClick={() => setSelectedCompetitorOnMap()}
                                                            >
                                                                <div className="competitor-name">{companyData.name || ""}</div>
                                                                {companyData.streetAddress1 && (
                                                                    <div className="competitor-detail">
                                                                        <span className="competitor-label">
                                                                            {companyData.streetAddress1}
                                                                        </span>
                                                                    </div>
                                                                )}

                                                                {businessRatingData && businessRatingData.reviewRating ? (
                                                                    <div className="competitor-detail">
                                                                        <span>{businessRatingData.reviewRating}</span>
                                                                        <span className="ms-2">
                                                                            <RatingStars rating={businessRatingData.reviewRating} />
                                                                        </span>
                                                                        {businessRatingData.reviewsCount && (
                                                                            <span className="ms-2">
                                                                                {`(${businessRatingData.reviewsCount})`}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <Fragment />
                                                                )}

                                                                {businessGridAverageDataByKeyword && (
                                                                    <div className="competitor-detail">
                                                                        <span className="competitor-label">
                                                                            Average Rank:
                                                                            <span className="average-rank-value">
                                                                                {businessGridAverageDataByKeyword}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className="map-side-panel competitors">
                                                        {competitorsData && competitorsData.length > 0 && (
                                                            <Fragment>
                                                                {competitorsData.map((competitor, index) => (
                                                                    <Fragment key={index}>
                                                                        {competitor.place_id && (
                                                                            <div
                                                                                className={`panel-wrapper competitor-item ${
                                                                                    selectedCompetitorOnMap &&
                                                                                    selectedCompetitorOnMap.place_id === competitor.place_id
                                                                                        ? "active"
                                                                                        : ""
                                                                                }`}
                                                                                key={index}
                                                                                onClick={() => handleSelectCompetitorOnMap(competitor)}
                                                                            >
                                                                                <div className="competitor-name">
                                                                                    {competitor.title || ""}
                                                                                </div>

                                                                                {competitor.address && (
                                                                                    <div className="competitor-detail">
                                                                                        <span className="competitor-label">
                                                                                            {competitor.address}
                                                                                        </span>
                                                                                    </div>
                                                                                )}

                                                                                {competitor.reviewRating ? (
                                                                                    <div className="competitor-detail">
                                                                                        <span>{competitor.reviewRating}</span>
                                                                                        <span className="ms-2">
                                                                                            <RatingStars rating={competitor.reviewRating} />
                                                                                        </span>
                                                                                        {competitor.reviewsCount && (
                                                                                            <span className="ms-2">
                                                                                                {`(${competitor.reviewsCount})`}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                ) : (
                                                                                    <Fragment />
                                                                                )}

                                                                                {competitor.average && (
                                                                                    <div className="competitor-detail">
                                                                                        <span className="competitor-label">
                                                                                            Average Rank:
                                                                                            <span className="average-rank-value">
                                                                                                {competitor.average}
                                                                                            </span>
                                                                                        </span>
                                                                                    </div>
                                                                                )}

                                                                                <div className="competitor-ordinal">
                                                                                    <span>{index + 1}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Fragment>
                                                                ))}
                                                            </Fragment>
                                                        )}
                                                    </div>
                                                </div>
                                            </Fragment>
                                        )}
                                    </Fragment>
                                </div>
                            </div>
                        )}

                        {currentReportTab === "seo" && (
                            <div className={`tab-pane fade position-relative ${currentReportTab === "seo" ? "show active" : ""}`}>
                                <div className="seo-data-container">
                                    {gridKeywords && gridKeywords.length > 0 && (
                                        <div className="panel-wrapper keywords-wrapper">
                                            {gridKeywords.map((keywordName, index) => (
                                                <button
                                                    className={`btn panel-report${
                                                        selectedKeyword && selectedKeyword === keywordName ? " active" : ""
                                                    } me-2`}
                                                    onClick={() => handleSelectKeyword(keywordName)}
                                                    disabled={isLoadingTask}
                                                    key={index}
                                                >
                                                    {keywordName}
                                                </button>
                                            ))}
                                        </div>
                                    )}

                                    <div className="table-wrapper">
                                        {isLoadingAuditData ? (
                                            <div className="text-center">
                                                <Spinner />
                                            </div>
                                        ) : (
                                            <table className="items-list audit-table table table-responsive">
                                                {auditResponseData &&
                                                auditResponseData.length > 0 &&
                                                auditKeywordData &&
                                                auditKeywordData.length > 0 ? (
                                                    <Fragment>
                                                        <thead>
                                                            <tr className={`col-competitor${3}`}>
                                                                <th className={`business text-start col-competitor${3} text-truncate`}>
                                                                    <span className="rank">#3</span>
                                                                    <span>
                                                                        {competitorsData && competitorsData.length > 2
                                                                            ? competitorsData[2].title
                                                                            : ""}
                                                                    </span>
                                                                </th>
                                                                <th className={`business col-competitor${3}`} />
                                                                <th className={`business col-competitor${3}`} />
                                                                <th className={`business col-competitor${3}`} />
                                                                <th className={`business col-competitor${3}`} />
                                                            </tr>

                                                            <tr className={`col-competitor${2}`}>
                                                                <th className={`business text-start col-competitor${2} text-truncate`}>
                                                                    <span className="rank">#2</span>
                                                                    <span>
                                                                        {competitorsData && competitorsData.length > 1
                                                                            ? competitorsData[1].title
                                                                            : ""}
                                                                    </span>
                                                                </th>
                                                                <th className={`business col-competitor${2}`} />
                                                                <th className={`business col-competitor${2}`} />
                                                                <th className={`business col-competitor${2}`} />
                                                                <th className={`business col-competitor${3}`} />
                                                            </tr>

                                                            <tr className={`col-competitor${1}`}>
                                                                <th className={`business text-start col-competitor${1} text-truncate`}>
                                                                    <span className="rank">#1</span>
                                                                    <span>
                                                                        {competitorsData && competitorsData.length > 0
                                                                            ? competitorsData[0].title
                                                                            : ""}
                                                                    </span>
                                                                </th>
                                                                <th className={`business col-competitor${1}`} />
                                                                <th className={`business col-competitor${1}`} />
                                                                <th className={`business col-competitor${2}`} />
                                                                <th className={`business col-competitor${3}`} />
                                                            </tr>

                                                            <tr className={`col-business`}>
                                                                <th className={`business text-start col-business text-truncate`}>
                                                                    <span className="icon">
                                                                        <i className="fa-solid fa-location-dot" />
                                                                    </span>
                                                                    <span>
                                                                        {auditKeywordData[0].profile
                                                                            ? auditKeywordData[0].profile.title
                                                                            : ""}
                                                                    </span>
                                                                </th>
                                                                <th className={`business col-business`} />
                                                                <th className={`business col-competitor${1}`} />
                                                                <th className={`business col-competitor${2}`} />
                                                                <th className={`business col-competitor${3}`} />
                                                            </tr>

                                                            <tr className="gbp-row">
                                                                <th className="separator-row" />
                                                                <th className={`separator-row text-center`}>
                                                                    {companyData && companyData.googleBusinessUrl && (
                                                                        <a
                                                                            className="btn btn-link p-0"
                                                                            href={companyData.googleBusinessUrl}
                                                                            target="_blank"
                                                                        >
                                                                            <span>View GBP</span>
                                                                        </a>
                                                                    )}
                                                                </th>
                                                                <th className={`separator-row text-center`}>
                                                                    {competitorsData &&
                                                                        competitorsData.length > 0 &&
                                                                        competitorsData[0].data_cid && (
                                                                            <a
                                                                                className="btn btn-link p-0"
                                                                                href={`https://maps.google.com/?cid=${
                                                                                    competitorsData[0].data_cid
                                                                                }`}
                                                                                target="_blank"
                                                                            >
                                                                                <span>View GBP</span>
                                                                            </a>
                                                                        )}
                                                                </th>
                                                                <th className={`separator-row text-center`}>
                                                                    {competitorsData &&
                                                                        competitorsData.length > 1 &&
                                                                        competitorsData[1].data_cid && (
                                                                            <a
                                                                                className="btn btn-link p-0"
                                                                                href={`https://maps.google.com/?cid=${
                                                                                    competitorsData[1].data_cid
                                                                                }`}
                                                                                target="_blank"
                                                                            >
                                                                                <span>View GBP</span>
                                                                            </a>
                                                                        )}
                                                                </th>
                                                                <th className={`separator-row text-center`}>
                                                                    {competitorsData &&
                                                                        competitorsData.length > 2 &&
                                                                        competitorsData[2].data_cid && (
                                                                            <a
                                                                                className="btn btn-link p-0"
                                                                                href={`https://maps.google.com/?cid=${
                                                                                    competitorsData[2].data_cid
                                                                                }`}
                                                                                target="_blank"
                                                                            >
                                                                                <span>View GBP</span>
                                                                            </a>
                                                                        )}
                                                                </th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {/* Average Profile Rank */}
                                                            <tr>
                                                                <td className="description">Average Profile Rank</td>
                                                                {auditKeywordData.map((business, index) => (
                                                                    <td
                                                                        key={index}
                                                                        className={`business col-${
                                                                            index === 0 ? "business" : `competitor${index}`
                                                                        }`}
                                                                    >
                                                                        {index === 0 ? (
                                                                            businessGridAverageDataByKeyword
                                                                        ) : (
                                                                            <Fragment>
                                                                                {competitorsData &&
                                                                                    competitorsData.length > 0 &&
                                                                                    competitorsData[index] && (
                                                                                        <span>{competitorsData[index].average || ""}</span>
                                                                                    )}
                                                                            </Fragment>
                                                                        )}
                                                                    </td>
                                                                ))}
                                                            </tr>

                                                            <tr>
                                                                <td className="separator-line" colSpan={5} />
                                                            </tr>

                                                            <tr>
                                                                <td colSpan={5} className="separator-row">
                                                                    <strong>Profile Settings</strong>
                                                                </td>
                                                            </tr>

                                                            {/* Profile Settings */}
                                                            {settings.map((setting) => (
                                                                <tr key={setting.label}>
                                                                    <td className="description">{setting.label}</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        // let businessData = business;

                                                                        // if (index > 0) {
                                                                        // 	businessData = {
                                                                        // 		...auditKeywordData[0],
                                                                        // 		pageSEO      : business.pageSEO,
                                                                        // 		keywordsIn   : business.KeywordsIn,
                                                                        // 		powerContent : business.powerContent
                                                                        // 	};
                                                                        // }

                                                                        // let propValue = businessData[setting.propName];
                                                                        let propValue = business[setting.propName];

                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business col-${
                                                                                    index === 0 ? "business" : `competitor${index}`
                                                                                }`}
                                                                            >
                                                                                {propValue ? (
                                                                                    <Fragment>
                                                                                        {setting.printPropName ? (
                                                                                            <button
                                                                                                className="btn btn-link p-0 btn-json-output"
                                                                                                onClick={() =>
                                                                                                    printJsonNodeValue(index, setting)
                                                                                                }
                                                                                            >
                                                                                                <span>
                                                                                                    {isNumber(propValue)
                                                                                                        ? propValue
                                                                                                        : "Yes"}
                                                                                                </span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <span>
                                                                                                {isNumber(propValue) ? propValue : "Yes"}
                                                                                            </span>
                                                                                        )}
                                                                                    </Fragment>
                                                                                ) : (
                                                                                    <span className="json-output-no-value">No</span>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))}

                                                            <tr>
                                                                <td className="separator-line" colSpan={5} />
                                                            </tr>

                                                            <tr>
                                                                <td colSpan={5} className="separator-row">
                                                                    <div>
                                                                        <strong>Keywords Relevance</strong>
                                                                    </div>
                                                                    <div>
                                                                        Relevance refers to how well a business matches what someone is
                                                                        searching for.
                                                                    </div>
                                                                    <div>
                                                                        <i>
                                                                            (
                                                                            {`Is the keyword ${`"${selectedKeyword}"` || ""} included in the
																			following items?`}
                                                                            )
                                                                        </i>
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            {/* Keywords In Settings */}
                                                            {kwSettings.map((setting) => (
                                                                <tr key={setting.label}>
                                                                    <td className="description">{setting.label}</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        let propValue = business[setting.propName];
                                                                        let hoverPropValue = business.keywordsIn
                                                                            ? business.keywordsIn[setting.hoverPropName]
                                                                            : "";

                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business col-${
                                                                                    index === 0 ? "business" : `competitor${index}`
                                                                                }`}
                                                                            >
                                                                                {propValue ? (
                                                                                    <Fragment>
                                                                                        {setting.printPropName ? (
                                                                                            <button
                                                                                                className="btn btn-link p-0 btn-json-output"
                                                                                                title={hoverPropValue}
                                                                                                onClick={() =>
                                                                                                    printJsonNodeValue(index, setting)
                                                                                                }
                                                                                            >
                                                                                                <span>
                                                                                                    {isNumber(propValue)
                                                                                                        ? propValue
                                                                                                        : "Yes"}
                                                                                                </span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <span title={hoverPropValue}>
                                                                                                {isNumber(propValue) ? propValue : "Yes"}
                                                                                            </span>
                                                                                        )}
                                                                                    </Fragment>
                                                                                ) : (
                                                                                    // <button
                                                                                    // 	className="btn btn-link p-0 btn-json-output json-output-no-value"
                                                                                    // 	title={hoverPropValue}
                                                                                    // 	onClick={() =>
                                                                                    // 		printJsonNodeValue(
                                                                                    // 			index,
                                                                                    // 			setting
                                                                                    // 		)}
                                                                                    // >
                                                                                    // 	<span>
                                                                                    // 		{isNumber(propValue) ? (
                                                                                    // 			0
                                                                                    // 		) : (
                                                                                    // 			'No'
                                                                                    // 		)}
                                                                                    // 	</span>
                                                                                    // </button>
                                                                                    <span className="json-output-no-value">
                                                                                        {isNumber(propValue) ? 0 : "No"}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))}

                                                            {/* Power Content */}
                                                            {auditKeywordData[0] &&
                                                                auditKeywordData[0].powerContent &&
                                                                auditKeywordData[0].powerContent.length > 0 && (
                                                                    <Fragment>
                                                                        <tr>
                                                                            <td colSpan={5} className="separator-row subrow">
                                                                                <strong>Power Content</strong>
                                                                            </td>
                                                                        </tr>
                                                                        {auditKeywordData[0].powerContent.map((pc, pcIndex) => {
                                                                            let websiteSlug = pc.website
                                                                                .replace("https://", "")
                                                                                .replace("www.", "")
                                                                                .replace(".", "__");
                                                                            let websiteHost = pc.website
                                                                                .replace("https://", "")
                                                                                .replace("www.", "");

                                                                            return (
                                                                                <tr key={pcIndex}>
                                                                                    <td className="description">{websiteHost}</td>
                                                                                    {auditKeywordData.map((business, index) => {
                                                                                        let pcValue = business.totalPowerContent
                                                                                            ? business.totalPowerContent[websiteHost]
                                                                                            : false;
                                                                                        let printSetting = {
                                                                                            label: "Power Content",
                                                                                            propName: pc.website,
                                                                                            printPropName: `powerContent.${websiteSlug}`,
                                                                                        };

                                                                                        return (
                                                                                            <td
                                                                                                key={index}
                                                                                                className={`business col-${
                                                                                                    index === 0
                                                                                                        ? "business"
                                                                                                        : `competitor${index}`
                                                                                                }`}
                                                                                            >
                                                                                                {pcValue ? (
                                                                                                    <Fragment>
                                                                                                        <button
                                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                                            onClick={() =>
                                                                                                                printJsonNodeValue(
                                                                                                                    index,
                                                                                                                    printSetting,
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <span>Yes</span>
                                                                                                        </button>
                                                                                                    </Fragment>
                                                                                                ) : (
                                                                                                    <span className="json-output-no-value">
                                                                                                        No
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </Fragment>
                                                                )}

                                                            <tr>
                                                                <td className="separator-line" colSpan={5} />
                                                            </tr>

                                                            <tr>
                                                                <td colSpan={5} className="separator-row">
                                                                    <div>
                                                                        <strong>Prominence</strong>
                                                                    </div>
                                                                    <div>
                                                                        Prominence is also based on information that Google has about a
                                                                        business, from across the web, like links, articles, and directories
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            {/* Domain Age */}
                                                            {/* <tr>
																<td className="description">Domain Age</td>
																{auditKeywordData.map((business, index) => {
																	return (
																		<td
																			key={index}
																			className={`business col-${index === 0
																				? 'business'
																				: `competitor${index}`}`}
																		>
																			{business.domainAge !== null &&
																			business.domainAge !== '' &&
																			business.domainAge !== -1 ? (
																				`${business.domainAge} ${business.domainAge ===
																				1
																					? 'Year'
																					: 'Years'}`
																			) : (
																				''
																			)}
																		</td>
																	);
																})}
															</tr> */}

                                                            {/* Total Indexed Pages */}
                                                            <tr>
                                                                <td className="description">Total Indexed Pages</td>
                                                                {auditKeywordData.map((business, index) => {
                                                                    let printSetting = {
                                                                        label: "Indexed Pages",
                                                                        propName: "totalIndexedPages",
                                                                        printPropName: "indexedPages.results",
                                                                    };

                                                                    return (
                                                                        <td
                                                                            key={index}
                                                                            className={`business col-${
                                                                                index === 0 ? "business" : `competitor${index}`
                                                                            }`}
                                                                        >
                                                                            {business.totalIndexedPages ? (
                                                                                <button
                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                    title={business.totalIndexedPages}
                                                                                    onClick={() => printJsonNodeValue(index, printSetting)}
                                                                                >
                                                                                    <span>{business.totalIndexedPages}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="json-output-no-value">0</span>
                                                                            )}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>

                                                            {/* Backlinks */}
                                                            <tr>
                                                                <td className="description">Backlinks</td>
                                                                {auditKeywordData.map((business, index) => (
                                                                    <td
                                                                        key={index}
                                                                        className={`business col-${
                                                                            index === 0 ? "business" : `competitor${index}`
                                                                        }`}
                                                                    >
                                                                        {business.totalBacklinks ? (
                                                                            <button
                                                                                className="btn btn-link p-0 btn-json-output"
                                                                                title={business.totalBacklinks}
                                                                            >
                                                                                <span>{business.totalBacklinks}</span>
                                                                            </button>
                                                                        ) : (
                                                                            <span className="json-output-no-value">0</span>
                                                                        )}
                                                                    </td>
                                                                ))}
                                                            </tr>

                                                            {/* Total Citations */}
                                                            <tr>
                                                                <td className="description">Total Citations</td>
                                                                {auditKeywordData.map((business, index) => {
                                                                    let printSetting = {
                                                                        label: "Citations",
                                                                        propName: "totalCitations",
                                                                        printPropName: "citations.results",
                                                                    };

                                                                    return (
                                                                        <td
                                                                            key={index}
                                                                            className={`business col-${
                                                                                index === 0 ? "business" : `competitor${index}`
                                                                            }`}
                                                                        >
                                                                            {business.totalCitations ? (
                                                                                <Fragment>
                                                                                    <button
                                                                                        className="btn btn-link p-0 btn-json-output"
                                                                                        onClick={() =>
                                                                                            printJsonNodeValue(index, printSetting)
                                                                                        }
                                                                                    >
                                                                                        <span>{business.totalCitations}</span>
                                                                                    </button>
                                                                                </Fragment>
                                                                            ) : (
                                                                                <span className="json-output-no-value">0</span>
                                                                            )}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>

                                                            {/* Power Citations */}
                                                            {auditKeywordData[0] &&
                                                                auditKeywordData[0].powerCitations &&
                                                                auditKeywordData[0].powerCitations.length > 0 && (
                                                                    <Fragment>
                                                                        <tr>
                                                                            <td colSpan={5} className="separator-row subrow">
                                                                                <strong>Power Citations</strong>
                                                                            </td>
                                                                        </tr>
                                                                        {auditKeywordData[0].powerCitations.map((pc, pcIndex) => {
                                                                            let websiteSlug = pc.website
                                                                                .replace("https://", "")
                                                                                .replace("www.", "")
                                                                                .replace(".", "__");

                                                                            return (
                                                                                <tr key={pcIndex}>
                                                                                    <td className="description">
                                                                                        {pc.website.replace("https://", "")}
                                                                                    </td>
                                                                                    {auditKeywordData.map((business, index) => {
                                                                                        let pcItem =
                                                                                            business.powerCitations &&
                                                                                            business.powerCitations.length > 0
                                                                                                ? business.powerCitations.find(
                                                                                                      (x) => x.website === pc.website,
                                                                                                  )
                                                                                                : null;
                                                                                        let printSetting = {
                                                                                            label: "Power Citations",
                                                                                            propName: pc.website,
                                                                                            printPropName: `powerCitations.${websiteSlug}`,
                                                                                        };

                                                                                        return (
                                                                                            <td
                                                                                                key={index}
                                                                                                className={`business col-${
                                                                                                    index === 0
                                                                                                        ? "business"
                                                                                                        : `competitor${index}`
                                                                                                }`}
                                                                                            >
                                                                                                {pcItem && pcItem.total ? (
                                                                                                    <Fragment>
                                                                                                        <button
                                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                                            title={pcItem.total}
                                                                                                            onClick={() =>
                                                                                                                printJsonNodeValue(
                                                                                                                    index,
                                                                                                                    printSetting,
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <span>Yes</span>
                                                                                                        </button>
                                                                                                    </Fragment>
                                                                                                ) : (
                                                                                                    <span className="json-output-no-value">
                                                                                                        No
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </Fragment>
                                                                )}

                                                            <tr>
                                                                <td className="separator-line" colSpan={5} />
                                                            </tr>

                                                            {/* Review Score */}
                                                            <tr>
                                                                <td className="separator-row" colSpan={5}>
                                                                    <div>
                                                                        <strong>Review Score</strong>
                                                                    </div>
                                                                    <div>
                                                                        More useful reviews with positive ratings and meaningful replies can
                                                                        improve your business' local ranking
                                                                    </div>
                                                                </td>
                                                            </tr>

                                                            {/* Total Reviews */}
                                                            <tr>
                                                                <td className="description">Total Reviews</td>
                                                                {auditKeywordData.map((business, index) => (
                                                                    <td
                                                                        key={index}
                                                                        className={`business col-${
                                                                            index === 0 ? "business" : `competitor${index}`
                                                                        }`}
                                                                    >
                                                                        {business.totalReviews ? (
                                                                            <button
                                                                                className="btn btn-link p-0 btn-json-output"
                                                                                title={business.totalReviews}
                                                                                onClick={() => printReviewsList(index, "total")}
                                                                            >
                                                                                <span>{business.totalReviews}</span>
                                                                            </button>
                                                                        ) : (
                                                                            <span className="json-output-no-value">0</span>
                                                                        )}
                                                                    </td>
                                                                ))}
                                                            </tr>

                                                            {/* Average Rating */}
                                                            <tr>
                                                                <td className="description">Average Rating</td>
                                                                {auditKeywordData.map((business, index) => (
                                                                    <td
                                                                        key={index}
                                                                        className={`business col-${
                                                                            index === 0 ? "business" : `competitor${index}`
                                                                        }`}
                                                                    >
                                                                        {business.averageRating ? (
                                                                            <button
                                                                                className="btn btn-link p-0 btn-json-output"
                                                                                title={business.averageRating}
                                                                                onClick={() => printReviewsList(index, "total")}
                                                                            >
                                                                                <span>{business.averageRating}</span>
                                                                            </button>
                                                                        ) : (
                                                                            <span className="json-output-no-value">0</span>
                                                                        )}
                                                                    </td>
                                                                ))}
                                                            </tr>

                                                            {/* Reviews Last 30 Days */}
                                                            <tr>
                                                                <td colSpan={5} className="separator-row subrow">
                                                                    <strong>Last 30 Days</strong>
                                                                </td>
                                                            </tr>
                                                            {reviewsLast30DaysSettings.map((setting) => (
                                                                <tr key={setting.label}>
                                                                    <td className="description">{setting.label}</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        let propValue = business[setting.propName];

                                                                        if (
                                                                            typeof propValue == "number" &&
                                                                            !isNaN(propValue) &&
                                                                            !Number.isInteger(propValue)
                                                                        ) {
                                                                            propValue = parseFloat(propValue).toFixed(1);
                                                                        }

                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business col-${
                                                                                    index === 0 ? "business" : `competitor${index}`
                                                                                }`}
                                                                            >
                                                                                {propValue ? (
                                                                                    <button
                                                                                        className="btn btn-link p-0 btn-json-output"
                                                                                        onClick={() =>
                                                                                            printReviewsList(
                                                                                                index,
                                                                                                "last30Days",
                                                                                                setting.propName,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <span>{propValue}</span>
                                                                                    </button>
                                                                                ) : (
                                                                                    <span className="json-output-no-value">0</span>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))}

                                                            {/* Last 20 Reviews */}
                                                            <tr>
                                                                <td colSpan={5} className="separator-row subrow">
                                                                    <strong>Last 20 Reviews</strong>
                                                                </td>
                                                            </tr>
                                                            {reviewsLast20Settings.map((setting) => (
                                                                <tr key={setting.label}>
                                                                    <td className="description">{setting.label}</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        let propValue = business[setting.propName];

                                                                        if (
                                                                            typeof propValue == "number" &&
                                                                            !isNaN(propValue) &&
                                                                            !Number.isInteger(propValue)
                                                                        ) {
                                                                            propValue = parseFloat(propValue).toFixed(1);
                                                                        }

                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business col-${
                                                                                    index === 0 ? "business" : `competitor${index}`
                                                                                }`}
                                                                            >
                                                                                {propValue ? (
                                                                                    <button
                                                                                        className="btn btn-link p-0 btn-json-output"
                                                                                        onClick={() =>
                                                                                            printReviewsList(
                                                                                                index,
                                                                                                "last20",
                                                                                                setting.propName,
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <span>{propValue}</span>
                                                                                    </button>
                                                                                ) : (
                                                                                    <span className="json-output-no-value">0</span>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            ))}

                                                            {/* Most Relevant Review Age */}
                                                            <tr>
                                                                <td className="description">Most Relevant Review Age</td>
                                                                {auditKeywordData.map((business, index) => {
                                                                    return (
                                                                        <td
                                                                            key={index}
                                                                            className={`business col-${
                                                                                index === 0 ? "business" : `competitor${index}`
                                                                            }`}
                                                                        >
                                                                            {business.mostRelevantReviewAge ? (
                                                                                <button
                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                    onClick={() => printReviewsList(index, "mostRelevant")}
                                                                                >
                                                                                    <span>
                                                                                        {business.mostRelevantReviewAge.replace(" ago", "")}
                                                                                    </span>
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        </tbody>
                                                    </Fragment>
                                                ) : (
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={5}>
                                                                <i>No Data</i>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {showJsonOutputDialog && (
                        <ModalDialog className="text-start" position="right-sidebar">
                            <ModalDialogContent align="start">
                                <div className="json-output-container">
                                    <div className="row" dangerouslySetInnerHTML={{ __html: jsonOutput }} />
                                </div>
                            </ModalDialogContent>
                            <ModalDialogButtons>
                                <div className="row">
                                    <div className="text-start col-12">
                                        <button className="btn btn-outline-primary" onClick={toggleJsonOutputDialog}>
                                            <span>Close</span>
                                        </button>
                                    </div>
                                </div>
                            </ModalDialogButtons>
                        </ModalDialog>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuditReportPublicView;
